<template>

  <div v-if="hasCredentials">
    <table class="table table-borderless table-border table-align table-h51">
      <thead>
      <tr>
        <th>Apelido</th>
        <th>app</th>
        <th>Serviço</th>
        <th>Preferencial</th>
        <th>Criado por</th>
        <th>Atualizado por</th>
        <th>Criado em</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="credential in credentials" :key="credential.id">
        <td>{{ credential.nickname }}</td>
        <td>{{ credential.appName }}</td>
        <td>{{ credential.serviceName }}</td>
        <td>{{ credential.preferential ? 'Sim' : 'Não' }}</td>
        <td>{{ credential.createdBy }}</td>
        <td>{{ credential.updatedBy || '-' }}</td>
        <td>{{ credential.createdAt | datetime }}</td>
        <td>{{ credential.updatedAt | datetime }}</td>
        <td class="text-right">
          <button @click="$emit('showCredential', credential)" class="btn-icon btn-outline">
            <edit-icon size="1.5x"/>
          </button>

          <button
              v-if="$withPolicy('application', 'credentials/delete')"
              @click="$emit('sendDeleteCredential', credential)"
              class="btn-icon btn-outline-red ml-2 mr-3"
          >
            <trash-2-icon size="1.5x"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <p class="mt-4">
      Não foi encontrada nenhuma credencial cadastrada
    </p>
  </div>

</template>

<script>
  import { Trash2Icon, EditIcon } from 'vue-feather-icons'

  export default {
    components: { EditIcon, Trash2Icon },
    name: 'Table',
    props: {
      credentials: { required: true, type: Array }
    },
    computed: {
      hasCredentials() {
        return this.credentials.length > 0
      },
    },
  }
</script>

<style scoped>

</style>
